/* eslint-disable */
import config from '../../config'
import styles from './index.module.scss'
import { Button, FormButton } from '../../components/core/button'
import { GeneralInput } from '../../components/core/input'
import StepLine from '../../components/core/stepLine'
import { useState, useRef, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  Account,
  LangArrows,
  Map,
  Education,
  Plus,
  Language,
  Work,
  Close,
  Cancel,
} from '../../icons'
import Helper from '../../utils/Helper'
import { PageContext } from '../../context/PageContextProvider'
import SelectsAPI from '../../api/selects'
import Loading from '../../components/pages/loading'
import translate from '../../utils/translate.json'
import VerifyAPI from '../../api/verify'
import { Module } from '../../components/core/module'

const RemoteStep1 = ({ className }) => {
  const { language, ChangeVerification } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [data, setData] = useState([])
  const [verify, setVerify] = useState(null)
  const [error, setError] = useState(null)
  const [module, setModule] = useState(false)
  useEffect(() => {
    (async () => {

    const { data } = await SelectsAPI.getGender()
    await setData(data)
    await setLoad(true)
  
    })();
  }, [])
  function generateGraduation() {
    var max = new Date().getFullYear() + 10
    var min = max - 75
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }
  const [choose, setChoose] = useState(translate.choose[language])
  const [year, setyear] = useState(translate.year[language])
  const [skillsList, setSkillsList] = useState([
    { id: 1, name: '', level: 'Orta', bool: false }
  ])
  const skillLevels = [
    { AZ: 'Başlanğıc', ENG: 'Beginner', RU: 'Начальный' },
    { AZ: 'Orta', ENG: 'Intermediate', RU: 'Средний' },
    { AZ: 'Yaxşı', ENG: 'Good', RU: 'Хороший' },
    { AZ: 'Əla', ENG: 'Excellent', RU: 'Отличный' },
    { AZ: 'Mütəxəssis', ENG: 'Expert', RU: 'Эксперт' },
  ]
  const addSkill = () => {
    setSkillsList((prev) => [
      ...prev,
      { id: Date.now(), name: '', level: 'Orta', bool: false }
    ])
  }
  const removeSkill = (skillId) => {
    if (skillsList.length === 1) {
      setSkillsList([{ id: Date.now(), name: '', level: 'Orta', bool: false }])
    } else {
      setSkillsList((prev) => prev.filter((s) => s.id !== skillId))
    }
  }
  const updateSkillName = (skillId, val) => {
    setSkillsList((prev) => prev.map((s) => (s.id === skillId ? { ...s, name: val } : s)))
  }
  const updateSkillLevel = (skillId, val) => {
    setSkillsList((prev) => prev.map((s) => (s.id === skillId ? { ...s, level: val, bool: false } : s)))
  }
  const toggleSkillDropdown = (skillId) => {
    setSkillsList((prev) =>
      prev.map((s) => (s.id === skillId ? { ...s, bool: !s.bool } : { ...s, bool: false }))
    )
  }
  const eduRef = useRef(null)
  const [isVisible4, setIsVisible4] = useState(false)
  const [gender, setGender] = useState(choose)
  const [graduation1, setGraduation1] = useState(year)
  const [graduation2, setGraduation2] = useState(year)
  const [graduation3, setGraduation3] = useState(year)
  const [graduation4, setGraduation4] = useState(year)
  const [graduation5, setGraduation5] = useState(year)
  const [graduation6, setGraduation6] = useState(year)
  const [graduation7, setGraduation7] = useState(year)
  const [graduation8, setGraduation8] = useState(year)
  const [graduation9, setGraduation9] = useState(year)
  const [graduation10, setGraduation10] = useState(year)
  const [edu1, setEdu1] = useState(false)
  const [edu2, setEdu2] = useState(false)
  const [edu3, setEdu3] = useState(false)
  const [edu4, setEdu4] = useState(false)
  const [edu5, setEdu5] = useState(false)
  const [edu6, setEdu6] = useState(false)
  const [edu7, setEdu7] = useState(false)
  const [edu8, setEdu8] = useState(false)
  const [edu9, setEdu9] = useState(false)
  const [edu10, setEdu10] = useState(false)
  const [booledu2, setBoolEdu2] = useState(false)
  const [booledu3, setBoolEdu3] = useState(false)
  const [booledu4, setBoolEdu4] = useState(false)
  const [booledu5, setBoolEdu5] = useState(false)
  const [booledu6, setBoolEdu6] = useState(false)
  const [booledu7, setBoolEdu7] = useState(false)
  const [booledu8, setBoolEdu8] = useState(false)
  const [booledu9, setBoolEdu9] = useState(false)
  const [booledu10, setBoolEdu10] = useState(false)

  const [reading1, setReading1] = useState(choose)
  const [reading2, setReading2] = useState(choose)
  const [reading3, setReading3] = useState(choose)
  const [reading4, setReading4] = useState(choose)
  const [reading5, setReading5] = useState(choose)
  const [reading6, setReading6] = useState(choose)
  const [reading7, setReading7] = useState(choose)
  const [reading8, setReading8] = useState(choose)
  const [reading9, setReading9] = useState(choose)
  const [reading10, setReading10] = useState(choose)
  const [readBool1, setreadBool1] = useState(false)
  const [readBool2, setreadBool2] = useState(false)
  const [readBool3, setreadBool3] = useState(false)
  const [readBool4, setreadBool4] = useState(false)
  const [readBool5, setreadBool5] = useState(false)
  const [readBool6, setreadBool6] = useState(false)
  const [readBool7, setreadBool7] = useState(false)
  const [readBool8, setreadBool8] = useState(false)
  const [readBool9, setreadBool9] = useState(false)
  const [readBool10, setreadBool10] = useState(false)

  const [writing1, setwriting1] = useState(choose)
  const [writing2, setwriting2] = useState(choose)
  const [writing3, setwriting3] = useState(choose)
  const [writing4, setwriting4] = useState(choose)
  const [writing5, setwriting5] = useState(choose)
  const [writing6, setwriting6] = useState(choose)
  const [writing7, setwriting7] = useState(choose)
  const [writing8, setwriting8] = useState(choose)
  const [writing9, setwriting9] = useState(choose)
  const [writing10, setwriting10] = useState(choose)
  const [writingBool1, setwritingBool1] = useState(false)
  const [writingBool2, setwritingBool2] = useState(false)
  const [writingBool3, setwritingBool3] = useState(false)
  const [writingBool4, setwritingBool4] = useState(false)
  const [writingBool5, setwritingBool5] = useState(false)
  const [writingBool6, setwritingBool6] = useState(false)
  const [writingBool7, setwritingBool7] = useState(false)
  const [writingBool8, setwritingBool8] = useState(false)
  const [writingBool9, setwritingBool9] = useState(false)
  const [writingBool10, setwritingBool10] = useState(false)

  const [speaking1, setspeaking1] = useState(choose)
  const [speaking2, setspeaking2] = useState(choose)
  const [speaking3, setspeaking3] = useState(choose)
  const [speaking4, setspeaking4] = useState(choose)
  const [speaking5, setspeaking5] = useState(choose)
  const [speaking6, setspeaking6] = useState(choose)
  const [speaking7, setspeaking7] = useState(choose)
  const [speaking8, setspeaking8] = useState(choose)
  const [speaking9, setspeaking9] = useState(choose)
  const [speaking10, setspeaking10] = useState(choose)
  const [speakingBool1, setspeakingBool1] = useState(false)
  const [speakingBool2, setspeakingBool2] = useState(false)
  const [speakingBool3, setspeakingBool3] = useState(false)
  const [speakingBool4, setspeakingBool4] = useState(false)
  const [speakingBool5, setspeakingBool5] = useState(false)
  const [speakingBool6, setspeakingBool6] = useState(false)
  const [speakingBool7, setspeakingBool7] = useState(false)
  const [speakingBool8, setspeakingBool8] = useState(false)
  const [speakingBool9, setspeakingBool9] = useState(false)
  const [speakingBool10, setspeakingBool10] = useState(false)

  const [listening1, setlistening1] = useState(choose)
  const [listening2, setlistening2] = useState(choose)
  const [listening3, setlistening3] = useState(choose)
  const [listening4, setlistening4] = useState(choose)
  const [listening5, setlistening5] = useState(choose)
  const [listening6, setlistening6] = useState(choose)
  const [listening7, setlistening7] = useState(choose)
  const [listening8, setlistening8] = useState(choose)
  const [listening9, setlistening9] = useState(choose)
  const [listening10, setlistening10] = useState(choose)
  const [listeningBool1, setlisteningBool1] = useState(false)
  const [listeningBool2, setlisteningBool2] = useState(false)
  const [listeningBool3, setlisteningBool3] = useState(false)
  const [listeningBool4, setlisteningBool4] = useState(false)
  const [listeningBool5, setlisteningBool5] = useState(false)
  const [listeningBool6, setlisteningBool6] = useState(false)
  const [listeningBool7, setlisteningBool7] = useState(false)
  const [listeningBool8, setlisteningBool8] = useState(false)
  const [listeningBool9, setlisteningBool9] = useState(false)
  const [listeningBool10, setlisteningBool10] = useState(false)

  const [boollang2, setBoollang2] = useState(false)
  const [boollang3, setBoollang3] = useState(false)
  const [boollang4, setBoollang4] = useState(false)
  const [boollang5, setBoollang5] = useState(false)
  const [boollang6, setBoollang6] = useState(false)
  const [boollang7, setBoollang7] = useState(false)
  const [boollang8, setBoollang8] = useState(false)
  const [boollang9, setBoollang9] = useState(false)
  const [boollang10, setBoollang10] = useState(false)

  let { id } = useParams()

  const graduations = generateGraduation()
  const percents = [
    '10%',
    '20%',
    '30%',
    '40%',
    '50%',
    '60%',
    '70%',
    '80%',
    '90%',
    '100%',
  ]
  const addEdu = () => {
    if (!booledu2) {
      setBoolEdu2(true)
    } else if (!booledu3) {
      setBoolEdu3(true)
    } else if (!booledu4) {
      setBoolEdu4(true)
    } else if (!booledu5) {
      setBoolEdu5(true)
    } else if (!booledu6) {
      setBoolEdu6(true)
    } else if (!booledu7) {
      setBoolEdu7(true)
    } else if (!booledu8) {
      setBoolEdu8(true)
    } else if (!booledu9) {
      setBoolEdu9(true)
    } else if (!booledu10) {
      setBoolEdu10(true)
    }
  }
  const addLang = () => {
    if (!boollang2) {
      setBoollang2(true)
    } else if (!boollang3) {
      setBoollang3(true)
    } else if (!boollang4) {
      setBoollang4(true)
    } else if (!boollang5) {
      setBoollang5(true)
    } else if (!boollang6) {
      setBoollang6(true)
    } else if (!boollang7) {
      setBoollang7(true)
    } else if (!boollang8) {
      setBoollang8(true)
    } else if (!boollang9) {
      setBoollang9(true)
    } else if (!boollang10) {
      setBoollang10(true)
    }
  }
  const [selectedImage, setSelectedImage] = useState(null)
  const [selectedFile, setSelectedFile] = useState(null)
  const steps = [
    {
      title: translate.add_info,
      text: {
        ENG: 'Add address and company name',
        AZ: 'Ünvan və şirkət adını əlavə edin',
        RU: 'Добавьте адрес и название компании',
      },
    },
    {
      title: translate.select_service,
      text: {
        ENG: 'Select the type of service you want to provide',
        AZ: 'Təmin etmək istədiyiniz xidmət növünü seçin',
        RU: 'Выберите тип услуги, которую вы хотите предоставить',
      },
    },
    {
      title: {
        AZ: 'Finiş',
        ENG: 'Finish',
        RU: 'Финиш',
      },
      text: {
        ENG: 'Your application has been approved',
        AZ: 'Müraciətiniz təsdiqləndi',
        RU: 'Ваша просьба одобрена',
      },
    },
  ]
  const sendAppeal = async () => {
    const fullname = await document
      .querySelector('#work-fullname')
      ?.value.trim()
    if (fullname === '') {
      alert(translate.alert[language])
      return
    }
    const birth = await document.querySelector('#work-birth')?.value.trim()
    if (birth === '') {
      alert(translate.alert[language])
      return
    }
    const phone1 = await document.querySelector('#work-phone1')?.value.trim()
    if (phone1 === '') {
      alert(translate.alert[language])
      return
    }
    if (
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone1,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone2 = await document.querySelector('#work-phone2')?.value.trim()
    if (
      phone2 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone2,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const email = await document.querySelector('#work-email')?.value.trim()
    if (email === '') {
      alert(translate.alert[language])
      return
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      alert(translate.alert_email[language])
      return
    }
    if (gender === choose) {
      alert(translate.alert[language])
      return
    }
    const addr = await document.querySelector('#work-address')?.value.trim()
    if (addr === '') {
      alert(translate.alert[language])
      return
    }
    const city = await document.querySelector('#work-city')?.value.trim()
    if (city === '') {
      alert(translate.alert[language])
      return
    }
    const country = await document.querySelector('#work-country')?.value.trim()
    if (country === '') {
      alert(translate.alert[language])
      return
    }
    const address = country + ' ' + city + ' ' + addr
    const uni1 = await document.querySelector('#work-university1')?.value.trim()
    const uni2 = await document.querySelector('#work-university2')?.value.trim()
    const uni3 = await document.querySelector('#work-university3')?.value.trim()
    const uni4 = await document.querySelector('#work-university4')?.value.trim()
    const uni5 = await document.querySelector('#work-university5')?.value.trim()
    const uni6 = await document.querySelector('#work-university6')?.value.trim()
    const uni7 = await document.querySelector('#work-university7')?.value.trim()
    const uni8 = await document.querySelector('#work-university8')?.value.trim()
    const uni9 = await document.querySelector('#work-university9')?.value.trim()
    const uni10 = await document
      .querySelector('#work-university10')
      ?.value.trim()
    const faculty1 = await document
      .querySelector('#work-faculty1')
      ?.value.trim()
    const faculty2 = await document
      .querySelector('#work-faculty2')
      ?.value.trim()
    const faculty3 = await document
      .querySelector('#work-faculty3')
      ?.value.trim()
    const faculty4 = await document
      .querySelector('#work-faculty4')
      ?.value.trim()
    const faculty5 = await document
      .querySelector('#work-faculty5')
      ?.value.trim()
    const faculty6 = await document
      .querySelector('#work-faculty6')
      ?.value.trim()
    const faculty7 = await document
      .querySelector('#work-faculty7')
      ?.value.trim()
    const faculty8 = await document
      .querySelector('#work-faculty8')
      ?.value.trim()
    const faculty9 = await document
      .querySelector('#work-faculty9')
      ?.value.trim()
    const faculty10 = await document
      .querySelector('#work-faculty10')
      ?.value.trim()
    const lang1 = await document.querySelector('#work-lang1')?.value.trim()
    const lang2 = await document.querySelector('#work-lang2')?.value.trim()
    const lang3 = await document.querySelector('#work-lang3')?.value.trim()
    const lang4 = await document.querySelector('#work-lang4')?.value.trim()
    const lang5 = await document.querySelector('#work-lang5')?.value.trim()
    const lang6 = await document.querySelector('#work-lang6')?.value.trim()
    const lang7 = await document.querySelector('#work-lang7')?.value.trim()
    const lang8 = await document.querySelector('#work-lang8')?.value.trim()
    const lang9 = await document.querySelector('#work-lang9')?.value.trim()
    const lang10 = await document.querySelector('#work-lang10')?.value.trim()
    if (
      uni1 === '' ||
      faculty1 === '' ||
      lang1 === '' ||
      graduation1 === year
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      booledu2 &&
      (uni2 === '' || faculty2 === '' || lang2 === '' || graduation2 === year)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      booledu3 &&
      (uni3 === '' || faculty3 === '' || lang3 === '' || graduation3 === year)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      booledu4 &&
      (uni4 === '' || faculty4 === '' || lang4 === '' || graduation4 === year)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      booledu5 &&
      (uni5 === '' || faculty5 === '' || lang5 === '' || graduation5 === year)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      booledu6 &&
      (uni6 === '' || faculty6 === '' || lang6 === '' || graduation6 === year)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      booledu7 &&
      (uni7 === '' || faculty7 === '' || lang7 === '' || graduation7 === year)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      booledu8 &&
      (uni8 === '' || faculty8 === '' || lang8 === '' || graduation8 === year)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      booledu9 &&
      (uni9 === '' || faculty9 === '' || lang9 === '' || graduation9 === year)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      booledu10 &&
      (uni10 === '' ||
        faculty10 === '' ||
        lang10 === '' ||
        graduation10 === year)
    ) {
      alert(translate.alert[language])
      return
    }
    let education = [
      {
        university: uni1,
        faculty: faculty1,
        language: lang1,
        graduationYear: graduation1,
      },
      booledu2 && {
        university: uni2,
        faculty: faculty2,
        language: lang2,
        graduationYear: graduation2,
      },
      booledu3 && {
        university: uni3,
        faculty: faculty3,
        language: lang3,
        graduationYear: graduation3,
      },
      booledu4 && {
        university: uni4,
        faculty: faculty4,
        language: lang4,
        graduationYear: graduation4,
      },
      booledu5 && {
        university: uni5,
        faculty: faculty5,
        language: lang5,
        graduationYear: graduation5,
      },
      booledu6 && {
        university: uni6,
        faculty: faculty6,
        language: lang6,
        graduationYear: graduation6,
      },
      booledu7 && {
        university: uni7,
        faculty: faculty7,
        language: lang7,
        graduationYear: graduation7,
      },
      booledu8 && {
        university: uni8,
        faculty: faculty8,
        language: lang8,
        graduationYear: graduation8,
      },
      booledu9 && {
        university: uni9,
        faculty: faculty9,
        language: lang9,
        graduationYear: graduation9,
      },
      booledu10 && {
        university: uni10,
        faculty: faculty10,
        language: lang10,
        graduationYear: graduation10,
      },
    ]
    education = education.filter((item) => item !== false)
    const language1 = await document
      .querySelector('#work-language1')
      ?.value.trim()
    const language2 = await document
      .querySelector('#work-language2')
      ?.value.trim()
    const language3 = await document
      .querySelector('#work-language3')
      ?.value.trim()
    const language4 = await document
      .querySelector('#work-language4')
      ?.value.trim()
    const language5 = await document
      .querySelector('#work-language5')
      ?.value.trim()
    const language6 = await document
      .querySelector('#work-language6')
      ?.value.trim()
    const language7 = await document
      .querySelector('#work-language7')
      ?.value.trim()
    const language8 = await document
      .querySelector('#work-language8')
      ?.value.trim()
    const language9 = await document
      .querySelector('#work-language9')
      ?.value.trim()
    const language10 = await document
      .querySelector('#work-language10')
      ?.value.trim()

    if (
      language1 === '' ||
      reading1 === choose ||
      writing1 === choose ||
      speaking1 === choose ||
      listening1 === choose
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      boollang2 &&
      (language2 === '' ||
        reading2 === choose ||
        writing2 === choose ||
        speaking2 === choose ||
        listening2 === choose)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      boollang3 &&
      (language3 === '' ||
        reading3 === choose ||
        writing3 === choose ||
        speaking3 === choose ||
        listening3 === choose)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      boollang4 &&
      (language4 === '' ||
        reading4 === choose ||
        writing4 === choose ||
        speaking4 === choose ||
        listening4 === choose)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      boollang5 &&
      (language5 === '' ||
        reading5 === choose ||
        writing5 === choose ||
        speaking5 === choose ||
        listening5 === choose)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      boollang6 &&
      (language6 === '' ||
        reading6 === choose ||
        writing6 === choose ||
        speaking6 === choose ||
        listening6 === choose)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      boollang7 &&
      (language7 === '' ||
        reading7 === choose ||
        writing7 === choose ||
        speaking7 === choose ||
        listening7 === choose)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      boollang8 &&
      (language8 === '' ||
        reading8 === choose ||
        writing8 === choose ||
        speaking8 === choose ||
        listening8 === choose)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      boollang9 &&
      (language9 === '' ||
        reading9 === choose ||
        writing9 === choose ||
        speaking9 === choose ||
        listening9 === choose)
    ) {
      alert(translate.alert[language])
      return
    }
    if (
      boollang10 &&
      (language10 === '' ||
        reading10 === choose ||
        writing10 === choose ||
        speaking10 === choose ||
        listening10 === choose)
    ) {
      alert(translate.alert[language])
      return
    }
    let languageSkills = [
      {
        language: language1,
        Reading: reading1,
        Writing: writing1,
        Speaking: speaking1,
        Listening: listening1,
      },
      boollang2 && {
        language: language2,
        Reading: reading2,
        Writing: writing2,
        Speaking: speaking2,
        Listening: listening2,
      },
      boollang3 && {
        language: language3,
        Reading: reading3,
        Writing: writing3,
        Speaking: speaking3,
        Listening: listening3,
      },
      boollang4 && {
        language: language4,
        Reading: reading4,
        Writing: writing4,
        Speaking: speaking4,
        Listening: listening4,
      },
      boollang5 && {
        language: language5,
        Reading: reading5,
        Writing: writing5,
        Speaking: speaking5,
        Listening: listening5,
      },
      boollang6 && {
        language: language6,
        Reading: reading6,
        Writing: writing6,
        Speaking: speaking6,
        Listening: listening6,
      },
      boollang7 && {
        language: language7,
        Reading: reading7,
        Writing: writing7,
        Speaking: speaking7,
        Listening: listening7,
      },
      boollang8 && {
        language: language8,
        Reading: reading8,
        Writing: writing8,
        Speaking: speaking8,
        Listening: listening8,
      },
      boollang9 && {
        language: language9,
        Reading: reading9,
        Writing: writing9,
        Speaking: speaking9,
        Listening: listening9,
      },
      boollang10 && {
        language: language10,
        Reading: reading10,
        Writing: writing10,
        Speaking: speaking10,
        Listening: listening10,
      },
    ]
    languageSkills = languageSkills.filter((item) => item)
    const company = await document.querySelector('#work-company')?.value.trim()
    if (company === '') {
      alert(translate.alert[language])
      return
    }
    const position = await document
      .querySelector('#work-position')
      ?.value.trim()
    if (position === '') {
      alert(translate.alert[language])
      return
    }
    const exp = await document.querySelector('#work-experience')?.value.trim()
    if (exp === '') {
      alert(translate.alert[language])
      return
    }
    const field = await document.querySelector('#work-field')?.value.trim()
    if (field === '') {
      alert(translate.alert[language])
      return
    }
    const experience = {
      company: company,
      position: position,
      generalExperience: exp,
      fieldExperience: field,
    }
    const note = await document.querySelector('#work-note')?.value.trim()
    const file = selectedImage
    const file2 = selectedFile
    const img = await fetch(
      'config.API_URL/s3Url',
    ).then((res) => res.json())
    const cv = await fetch(
      'config.API_URL/s3Url',
    ).then((res) => res.json())
    if (!selectedImage) {
      alert(translate.alert_photo[language])
      return
    }
    if (!selectedFile) {
      alert(translate.alert_cv[language])
      return
    }
    if (selectedImage) {
      await fetch(img.url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        body: file,
      })
    }
    if (selectedFile) {
      await fetch(cv.url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        body: file2,
      })
    }

    const photoLocation = selectedImage
      ? img.url.split('?')[0].split('.com/')[1]
      : 'no image'
    const resumeLocation = selectedFile
      ? cv.url.split('?')[0].split('.com/')[1]
      : 'no cv'
    const data = await {
      fullname,
      birth,
      gender,
      phone1,
      phone2,
      email,
      address,
      education,
      languageSkills,
      experience,
      photoLocation,
      resumeLocation,
      note,
      skills: skillsList.filter((s) => s.name.trim() !== ''),
      options: [],
      fiedlsToWork: [],
    }
    await sessionStorage.setItem('work', JSON.stringify(data))
    await console.log(data)
    window.location.href = await '/remote-work-step2'
  }
  return load ? (
    <>
      <section className={`${className} ${styles.container}`}>
        <StepLine active={0} data={steps} />
        <div className={`${styles.content}`}>
          <h2>
            <Account /> {translate.about[language]}
          </h2>
          <div className={styles.about}>
            <GeneralInput
              id="work-fullname"
              label={translate.fullname[language]}
              type="text"
              placeholder={translate.enter_fullname[language]}
            />
            <div>
              <GeneralInput
                id="work-birth"
                label={translate.date[language]}
                type="date"
              />
            </div>
          </div>
          <div className={styles.email}>
            <GeneralInput
              label={translate.email[language]}
              type="text"
              id="work-email"
              placeholder={translate.email_ph[language]}
              onInput={(e) => {
                setError(
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    e.target.value,
                  ),
                )
              }}
              style={{
                border: error ? '1px solid red' : '1px solid #C5CEE0',
                width: '100%',
              }}
            />
          </div>
          <div className={styles.gender}>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setIsVisible4(false)
                }, 250)
              }
            >
              <p>{translate.gender[language]}</p>
              <span tabIndex="1" onClick={() => setIsVisible4(true)}>
                {gender} <LangArrows />
              </span>
              <ul
                style={isVisible4 ? { display: 'block' } : { display: 'none' }}
              >
                {data.map((e) => (
                  <li
                    onClick={() => {
                      setGender(e[language])
                    }}
                  >
                    {e[language]}
                  </li>
                ))}
              </ul>
            </div>
            <GeneralInput
              label={translate.phone[language]}
              id="work-phone1"
              type="tel"
              placeholder="+994 XX XXX XX XX"
            />
            <GeneralInput
              require={true}
              label={translate.phone2[language]}
              id="work-phone2"
              type="tel"
              placeholder="+994 XX XXX XX XX"
            />
          </div>

          <h2>
            <Map /> {translate.current_address[language]}
          </h2>
          <div className={styles.address}>
            <GeneralInput
              label={translate.country[language]}
              id="work-country"
              type="text"
              placeholder={translate.enter_info[language]}
            />
            <GeneralInput
              label={translate.city[language]}
              type="text"
              id="work-city"
              placeholder={translate.enter_info[language]}
            />
            <GeneralInput
              label={translate.address[language]}
              id="work-address"
              type="text"
              placeholder={translate.enter_info[language]}
            />
          </div>
          <h2>
            <Education /> {translate.education[language]}
            <span>({translate.edu_info[language]})</span>
          </h2>
          <div ref={eduRef} className={`education ${styles.education}`}>
            <div className={styles.edu}>
              <div>
                <GeneralInput
                  label={translate.university[language]}
                  id="work-university1"
                  type="text"
                  placeholder={translate.enter_info[language]}
                />
                <GeneralInput
                  label={translate.faculty[language]}
                  id="work-faculty1"
                  type="text"
                  placeholder={translate.enter_info[language]}
                />
              </div>
              <div>
                <GeneralInput
                  label={translate.lang_study[language]}
                  id="work-lang1"
                  type="text"
                  placeholder={translate.enter_info[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setEdu1(false)
                    }, 250)
                  }
                >
                  <p>{translate.gra_year[language]}</p>
                  <span tabIndex="1" onClick={() => setEdu1(true)}>
                    {graduation1} <LangArrows />
                  </span>
                  <ul style={edu1 ? { display: 'block' } : { display: 'none' }}>
                    {graduations.map((e) => (
                      <li
                        onClick={() => {
                          setGraduation1(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            {booledu2 ? (
              <div className={styles.edu}>
                <div>
                  <GeneralInput
                    id="work-university2"
                    label={translate.university[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <GeneralInput
                    id="work-faculty2"
                    label={translate.faculty[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                </div>
                <div>
                  <GeneralInput
                    id="work-lang2"
                    label={translate.lang_study[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <div
                    className={styles.select}
                    onBlur={() =>
                      setTimeout(function () {
                        setEdu2(false)
                      }, 250)
                    }
                  >
                    <p>{translate.gra_year[language]}</p>
                    <span tabIndex="1" onClick={() => setEdu2(true)}>
                      {graduation2} <LangArrows />
                    </span>
                    <ul
                      style={edu2 ? { display: 'block' } : { display: 'none' }}
                    >
                      {graduations.map((e) => (
                        <li
                          onClick={() => {
                            setGraduation2(e)
                          }}
                        >
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Cancel onClick={() => setBoolEdu2(false)} />
              </div>
            ) : null}
            {booledu3 ? (
              <div className={styles.edu}>
                <div>
                  <GeneralInput
                    id="work-university3"
                    label={translate.university[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <GeneralInput
                    id="work-faculty3"
                    label={translate.faculty[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                </div>
                <div>
                  <GeneralInput
                    id="work-lang3"
                    label={translate.lang_study[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <div
                    className={styles.select}
                    onBlur={() =>
                      setTimeout(function () {
                        setEdu3(false)
                      }, 250)
                    }
                  >
                    <p>{translate.gra_year[language]}</p>
                    <span tabIndex="1" onClick={() => setEdu3(true)}>
                      {graduation3} <LangArrows />
                    </span>
                    <ul
                      style={edu3 ? { display: 'block' } : { display: 'none' }}
                    >
                      {graduations.map((e) => (
                        <li
                          onClick={() => {
                            setGraduation3(e)
                          }}
                        >
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Cancel onClick={() => setBoolEdu3(false)} />
              </div>
            ) : null}
            {booledu4 ? (
              <div className={styles.edu}>
                <div>
                  <GeneralInput
                    id="work-university4"
                    label={translate.university[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <GeneralInput
                    id="work-faculty4"
                    label={translate.faculty[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                </div>
                <div>
                  <GeneralInput
                    id="work-lang4"
                    label={translate.lang_study[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <div
                    className={styles.select}
                    onBlur={() =>
                      setTimeout(function () {
                        setEdu4(false)
                      }, 250)
                    }
                  >
                    <p>{translate.gra_year[language]}</p>
                    <span tabIndex="1" onClick={() => setEdu4(true)}>
                      {graduation4} <LangArrows />
                    </span>
                    <ul
                      style={edu4 ? { display: 'block' } : { display: 'none' }}
                    >
                      {graduations.map((e) => (
                        <li
                          onClick={() => {
                            setGraduation4(e)
                          }}
                        >
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Cancel onClick={() => setBoolEdu4(false)} />
              </div>
            ) : null}
            {booledu5 ? (
              <div className={styles.edu}>
                <div>
                  <GeneralInput
                    id="work-university5"
                    label={translate.university[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <GeneralInput
                    id="work-faculty5"
                    label={translate.faculty[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                </div>
                <div>
                  <GeneralInput
                    id="work-lang5"
                    label={translate.lang_study[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <div
                    className={styles.select}
                    onBlur={() =>
                      setTimeout(function () {
                        setEdu5(false)
                      }, 250)
                    }
                  >
                    <p>{translate.gra_year[language]}</p>
                    <span tabIndex="1" onClick={() => setEdu5(true)}>
                      {graduation5} <LangArrows />
                    </span>
                    <ul
                      style={edu5 ? { display: 'block' } : { display: 'none' }}
                    >
                      {graduations.map((e) => (
                        <li
                          onClick={() => {
                            setGraduation5(e)
                          }}
                        >
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Cancel onClick={() => setBoolEdu5(false)} />
              </div>
            ) : null}
            {booledu6 ? (
              <div className={styles.edu}>
                <div>
                  <GeneralInput
                    id="work-university6"
                    label={translate.university[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <GeneralInput
                    id="work-faculty6"
                    label={translate.faculty[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                </div>
                <div>
                  <GeneralInput
                    id="work-lang6"
                    label={translate.lang_study[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <div
                    className={styles.select}
                    onBlur={() =>
                      setTimeout(function () {
                        setEdu6(false)
                      }, 250)
                    }
                  >
                    <p>{translate.gra_year[language]}</p>
                    <span tabIndex="1" onClick={() => setEdu6(true)}>
                      {graduation6} <LangArrows />
                    </span>
                    <ul
                      style={edu6 ? { display: 'block' } : { display: 'none' }}
                    >
                      {graduations.map((e) => (
                        <li
                          onClick={() => {
                            setGraduation6(e)
                          }}
                        >
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Cancel onClick={() => setBoolEdu6(false)} />
              </div>
            ) : null}
            {booledu7 ? (
              <div className={styles.edu}>
                <div>
                  <GeneralInput
                    id="work-university7"
                    label={translate.university[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <GeneralInput
                    id="work-faculty7"
                    label={translate.faculty[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                </div>
                <div>
                  <GeneralInput
                    id="work-lang7"
                    label={translate.lang_study[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <div
                    className={styles.select}
                    onBlur={() =>
                      setTimeout(function () {
                        setEdu7(false)
                      }, 250)
                    }
                  >
                    <p>{translate.gra_year[language]}</p>
                    <span tabIndex="1" onClick={() => setEdu7(true)}>
                      {graduation7} <LangArrows />
                    </span>
                    <ul
                      style={edu7 ? { display: 'block' } : { display: 'none' }}
                    >
                      {graduations.map((e) => (
                        <li
                          onClick={() => {
                            setGraduation7(e)
                          }}
                        >
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Cancel onClick={() => setBoolEdu7(false)} />
              </div>
            ) : null}
            {booledu8 ? (
              <div className={styles.edu}>
                <div>
                  <GeneralInput
                    id="work-university8"
                    label={translate.university[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <GeneralInput
                    id="work-faculty8"
                    label={translate.faculty[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                </div>
                <div>
                  <GeneralInput
                    id="work-lang8"
                    label={translate.lang_study[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <div
                    className={styles.select}
                    onBlur={() =>
                      setTimeout(function () {
                        setEdu8(false)
                      }, 250)
                    }
                  >
                    <p>{translate.gra_year[language]}</p>
                    <span tabIndex="1" onClick={() => setEdu8(true)}>
                      {graduation8} <LangArrows />
                    </span>
                    <ul
                      style={edu8 ? { display: 'block' } : { display: 'none' }}
                    >
                      {graduations.map((e) => (
                        <li
                          onClick={() => {
                            setGraduation8(e)
                          }}
                        >
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Cancel onClick={() => setBoolEdu8(false)} />
              </div>
            ) : null}
            {booledu9 ? (
              <div className={styles.edu}>
                <div>
                  <GeneralInput
                    id="work-university9"
                    label={translate.university[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <GeneralInput
                    id="work-faculty9"
                    label={translate.faculty[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                </div>
                <div>
                  <GeneralInput
                    id="work-lang9"
                    label={translate.lang_study[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <div
                    className={styles.select}
                    onBlur={() =>
                      setTimeout(function () {
                        setEdu9(false)
                      }, 250)
                    }
                  >
                    <p>{translate.gra_year[language]}</p>
                    <span tabIndex="1" onClick={() => setEdu9(true)}>
                      {graduation9} <LangArrows />
                    </span>
                    <ul
                      style={edu9 ? { display: 'block' } : { display: 'none' }}
                    >
                      {graduations.map((e) => (
                        <li
                          onClick={() => {
                            setGraduation9(e)
                          }}
                        >
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Cancel onClick={() => setBoolEdu9(false)} />
              </div>
            ) : null}
            {booledu10 ? (
              <div className={styles.edu}>
                <div>
                  <GeneralInput
                    id="work-university10"
                    label={translate.university[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <GeneralInput
                    id="work-faculty10"
                    label={translate.faculty[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                </div>
                <div>
                  <GeneralInput
                    id="work-lang10"
                    label={translate.lang_study[language]}
                    type="text"
                    placeholder={translate.enter_info[language]}
                  />
                  <div
                    className={styles.select}
                    onBlur={() =>
                      setTimeout(function () {
                        setEdu10(false)
                      }, 250)
                    }
                  >
                    <p>{translate.gra_year[language]}</p>
                    <span tabIndex="1" onClick={() => setEdu10(true)}>
                      {graduation10} <LangArrows />
                    </span>
                    <ul
                      style={edu10 ? { display: 'block' } : { display: 'none' }}
                    >
                      {graduations.map((e) => (
                        <li
                          onClick={() => {
                            setGraduation10(e)
                          }}
                        >
                          {e}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Cancel onClick={() => setBoolEdu10(false)} />
              </div>
            ) : null}
          </div>
          {!booledu10 && (
            <button
              onClick={() => {
                addEdu()
              }}
              className={styles.button}
            >
              <Plus /> {translate.add_edu[language]}
            </button>
          )}
          <h2>
            <Language /> {translate.lang_skills[language]}
            <span>({translate.lang_info[language]})</span>
          </h2>
          <div className={styles.language}>
            <div className={styles.lang}>
              <GeneralInput
                label={translate.language[language]}
                id="work-language1"
                type="text"
                placeholder={translate.enter_lang[language]}
              />
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool1(false)
                  }, 250)
                }
              >
                <p>{translate.reading[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool1(true)}>
                  {reading1} <LangArrows />
                </span>
                <ul
                  style={readBool1 ? { display: 'block' } : { display: 'none' }}
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setReading1(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool1(false)
                  }, 250)
                }
              >
                <p>{translate.writing[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool1(true)}>
                  {writing1} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool1 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setwriting1(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setspeakingBool1(false)
                  }, 250)
                }
              >
                <p>{translate.speaking[language]}</p>
                <span tabIndex="1" onClick={() => setspeakingBool1(true)}>
                  {speaking1} <LangArrows />
                </span>
                <ul
                  style={
                    speakingBool1 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setspeaking1(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setlisteningBool1(false)
                  }, 250)
                }
              >
                <p>{translate.listening[language]}</p>
                <span tabIndex="1" onClick={() => setlisteningBool1(true)}>
                  {listening1} <LangArrows />
                </span>
                <ul
                  style={
                    listeningBool1 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {percents.map((e) => (
                    <li
                      onClick={() => {
                        setlistening1(e)
                      }}
                    >
                      {e}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {boollang2 ? (
              <div className={styles.lang}>
                <GeneralInput
                  id="work-language2"
                  label={translate.language[language]}
                  type="text"
                  placeholder={translate.enter_lang[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setreadBool2(false)
                    }, 250)
                  }
                >
                  <p>{translate.reading[language]}</p>
                  <span tabIndex="1" onClick={() => setreadBool2(true)}>
                    {reading2} <LangArrows />
                  </span>
                  <ul
                    style={
                      readBool2 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setReading2(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setwritingBool2(false)
                    }, 250)
                  }
                >
                  <p>{translate.writing[language]}</p>
                  <span tabIndex="1" onClick={() => setwritingBool2(true)}>
                    {writing2} <LangArrows />
                  </span>
                  <ul
                    style={
                      writingBool2 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setwriting2(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setspeakingBool2(false)
                    }, 250)
                  }
                >
                  <p>{translate.speaking[language]}</p>
                  <span tabIndex="1" onClick={() => setspeakingBool2(true)}>
                    {speaking2} <LangArrows />
                  </span>
                  <ul
                    style={
                      speakingBool2 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setspeaking2(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setlisteningBool2(false)
                    }, 250)
                  }
                >
                  <p>{translate.listening[language]}</p>
                  <span tabIndex="1" onClick={() => setlisteningBool2(true)}>
                    {listening2} <LangArrows />
                  </span>
                  <ul
                    style={
                      listeningBool2
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setlistening2(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel onClick={() => setBoollang2(false)} />
              </div>
            ) : null}
            {boollang3 ? (
              <div className={styles.lang}>
                <GeneralInput
                  id="work-language3"
                  label={translate.language[language]}
                  type="text"
                  placeholder={translate.enter_lang[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setreadBool3(false)
                    }, 250)
                  }
                >
                  <p>{translate.reading[language]}</p>
                  <span tabIndex="1" onClick={() => setreadBool3(true)}>
                    {reading3} <LangArrows />
                  </span>
                  <ul
                    style={
                      readBool3 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setReading3(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setwritingBool3(false)
                    }, 250)
                  }
                >
                  <p>{translate.writing[language]}</p>
                  <span tabIndex="1" onClick={() => setwritingBool3(true)}>
                    {writing3} <LangArrows />
                  </span>
                  <ul
                    style={
                      writingBool3 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setwriting3(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setspeakingBool3(false)
                    }, 250)
                  }
                >
                  <p>{translate.speaking[language]}</p>
                  <span tabIndex="1" onClick={() => setspeakingBool3(true)}>
                    {speaking3} <LangArrows />
                  </span>
                  <ul
                    style={
                      speakingBool3 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setspeaking3(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setlisteningBool3(false)
                    }, 250)
                  }
                >
                  <p>{translate.listening[language]}</p>
                  <span tabIndex="1" onClick={() => setlisteningBool3(true)}>
                    {listening3} <LangArrows />
                  </span>
                  <ul
                    style={
                      listeningBool3
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setlistening3(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel onClick={() => setBoollang3(false)} />
              </div>
            ) : null}
            {boollang4 ? (
              <div className={styles.lang}>
                <GeneralInput
                  id="work-language4"
                  label={translate.language[language]}
                  type="text"
                  placeholder={translate.enter_lang[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setreadBool4(false)
                    }, 250)
                  }
                >
                  <p>{translate.reading[language]}</p>
                  <span tabIndex="1" onClick={() => setreadBool4(true)}>
                    {reading4} <LangArrows />
                  </span>
                  <ul
                    style={
                      readBool4 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setReading4(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setwritingBool4(false)
                    }, 250)
                  }
                >
                  <p>{translate.writing[language]}</p>
                  <span tabIndex="1" onClick={() => setwritingBool4(true)}>
                    {writing4} <LangArrows />
                  </span>
                  <ul
                    style={
                      writingBool4 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setwriting4(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setspeakingBool4(false)
                    }, 250)
                  }
                >
                  <p>{translate.speaking[language]}</p>
                  <span tabIndex="1" onClick={() => setspeakingBool4(true)}>
                    {speaking4} <LangArrows />
                  </span>
                  <ul
                    style={
                      speakingBool4 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setspeaking4(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setlisteningBool4(false)
                    }, 250)
                  }
                >
                  <p>{translate.listening[language]}</p>
                  <span tabIndex="1" onClick={() => setlisteningBool4(true)}>
                    {listening4} <LangArrows />
                  </span>
                  <ul
                    style={
                      listeningBool4
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setlistening4(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel onClick={() => setBoollang4(false)} />
              </div>
            ) : null}
            {boollang5 ? (
              <div className={styles.lang}>
                <GeneralInput
                  id="work-language5"
                  label={translate.language[language]}
                  type="text"
                  placeholder={translate.enter_lang[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setreadBool5(false)
                    }, 250)
                  }
                >
                  <p>{translate.reading[language]}</p>
                  <span tabIndex="1" onClick={() => setreadBool5(true)}>
                    {reading5} <LangArrows />
                  </span>
                  <ul
                    style={
                      readBool5 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setReading5(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setwritingBool5(false)
                    }, 250)
                  }
                >
                  <p>{translate.writing[language]}</p>
                  <span tabIndex="1" onClick={() => setwritingBool5(true)}>
                    {writing5} <LangArrows />
                  </span>
                  <ul
                    style={
                      writingBool5 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setwriting5(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setspeakingBool5(false)
                    }, 250)
                  }
                >
                  <p>{translate.speaking[language]}</p>
                  <span tabIndex="1" onClick={() => setspeakingBool5(true)}>
                    {speaking5} <LangArrows />
                  </span>
                  <ul
                    style={
                      speakingBool5 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setspeaking5(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setlisteningBool5(false)
                    }, 250)
                  }
                >
                  <p>{translate.listening[language]}</p>
                  <span tabIndex="1" onClick={() => setlisteningBool5(true)}>
                    {listening5} <LangArrows />
                  </span>
                  <ul
                    style={
                      listeningBool5
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setlistening5(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel onClick={() => setBoollang5(false)} />
              </div>
            ) : null}
            {boollang6 ? (
              <div className={styles.lang}>
                <GeneralInput
                  id="work-language6"
                  label={translate.language[language]}
                  type="text"
                  placeholder={translate.enter_lang[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setreadBool6(false)
                    }, 250)
                  }
                >
                  <p>{translate.reading[language]}</p>
                  <span tabIndex="1" onClick={() => setreadBool6(true)}>
                    {reading6} <LangArrows />
                  </span>
                  <ul
                    style={
                      readBool6 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setReading6(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setwritingBool6(false)
                    }, 250)
                  }
                >
                  <p>{translate.writing[language]}</p>
                  <span tabIndex="1" onClick={() => setwritingBool6(true)}>
                    {writing6} <LangArrows />
                  </span>
                  <ul
                    style={
                      writingBool6 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setwriting6(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setspeakingBool6(false)
                    }, 250)
                  }
                >
                  <p>{translate.speaking[language]}</p>
                  <span tabIndex="1" onClick={() => setspeakingBool6(true)}>
                    {speaking6} <LangArrows />
                  </span>
                  <ul
                    style={
                      speakingBool6 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setspeaking6(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setlisteningBool6(false)
                    }, 250)
                  }
                >
                  <p>{translate.listening[language]}</p>
                  <span tabIndex="1" onClick={() => setlisteningBool6(true)}>
                    {listening6} <LangArrows />
                  </span>
                  <ul
                    style={
                      listeningBool6
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setlistening6(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel onClick={() => setBoollang6(false)} />
              </div>
            ) : null}
            {boollang7 ? (
              <div className={styles.lang}>
                <GeneralInput
                  id="work-language7"
                  label={translate.language[language]}
                  type="text"
                  placeholder={translate.enter_lang[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setreadBool7(false)
                    }, 250)
                  }
                >
                  <p>{translate.reading[language]}</p>
                  <span tabIndex="1" onClick={() => setreadBool7(true)}>
                    {reading7} <LangArrows />
                  </span>
                  <ul
                    style={
                      readBool7 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setReading7(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setwritingBool7(false)
                    }, 250)
                  }
                >
                  <p>{translate.writing[language]}</p>
                  <span tabIndex="1" onClick={() => setwritingBool7(true)}>
                    {writing7} <LangArrows />
                  </span>
                  <ul
                    style={
                      writingBool7 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setwriting7(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setspeakingBool7(false)
                    }, 250)
                  }
                >
                  <p>{translate.speaking[language]}</p>
                  <span tabIndex="1" onClick={() => setspeakingBool7(true)}>
                    {speaking7} <LangArrows />
                  </span>
                  <ul
                    style={
                      speakingBool7 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setspeaking7(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setlisteningBool7(false)
                    }, 250)
                  }
                >
                  <p>{translate.listening[language]}</p>
                  <span tabIndex="1" onClick={() => setlisteningBool7(true)}>
                    {listening7} <LangArrows />
                  </span>
                  <ul
                    style={
                      listeningBool7
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setlistening7(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel onClick={() => setBoollang7(false)} />
              </div>
            ) : null}
            {boollang8 ? (
              <div className={styles.lang}>
                <GeneralInput
                  id="work-language8"
                  label={translate.language[language]}
                  type="text"
                  placeholder={translate.enter_lang[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setreadBool8(false)
                    }, 250)
                  }
                >
                  <p>{translate.reading[language]}</p>
                  <span tabIndex="1" onClick={() => setreadBool8(true)}>
                    {reading8} <LangArrows />
                  </span>
                  <ul
                    style={
                      readBool8 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setReading8(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setwritingBool8(false)
                    }, 250)
                  }
                >
                  <p>{translate.writing[language]}</p>
                  <span tabIndex="1" onClick={() => setwritingBool8(true)}>
                    {writing8} <LangArrows />
                  </span>
                  <ul
                    style={
                      writingBool8 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setwriting8(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setspeakingBool8(false)
                    }, 250)
                  }
                >
                  <p>{translate.speaking[language]}</p>
                  <span tabIndex="1" onClick={() => setspeakingBool8(true)}>
                    {speaking8} <LangArrows />
                  </span>
                  <ul
                    style={
                      speakingBool8 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setspeaking8(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setlisteningBool8(false)
                    }, 250)
                  }
                >
                  <p>{translate.listening[language]}</p>
                  <span tabIndex="1" onClick={() => setlisteningBool8(true)}>
                    {listening8} <LangArrows />
                  </span>
                  <ul
                    style={
                      listeningBool8
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setlistening8(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel onClick={() => setBoollang8(false)} />
              </div>
            ) : null}
            {boollang9 ? (
              <div className={styles.lang}>
                <GeneralInput
                  id="work-language9"
                  label={translate.language[language]}
                  type="text"
                  placeholder={translate.enter_lang[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setreadBool9(false)
                    }, 250)
                  }
                >
                  <p>{translate.reading[language]}</p>
                  <span tabIndex="1" onClick={() => setreadBool9(true)}>
                    {reading9} <LangArrows />
                  </span>
                  <ul
                    style={
                      readBool9 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setReading9(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setwritingBool9(false)
                    }, 250)
                  }
                >
                  <p>{translate.writing[language]}</p>
                  <span tabIndex="1" onClick={() => setwritingBool9(true)}>
                    {writing9} <LangArrows />
                  </span>
                  <ul
                    style={
                      writingBool9 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setwriting9(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setspeakingBool9(false)
                    }, 250)
                  }
                >
                  <p>{translate.speaking[language]}</p>
                  <span tabIndex="1" onClick={() => setspeakingBool9(true)}>
                    {speaking9} <LangArrows />
                  </span>
                  <ul
                    style={
                      speakingBool9 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setspeaking9(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setlisteningBool9(false)
                    }, 250)
                  }
                >
                  <p>{translate.listening[language]}</p>
                  <span tabIndex="1" onClick={() => setlisteningBool9(true)}>
                    {listening9} <LangArrows />
                  </span>
                  <ul
                    style={
                      listeningBool9
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setlistening9(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel onClick={() => setBoollang9(false)} />
              </div>
            ) : null}
            {boollang10 ? (
              <div className={styles.lang}>
                <GeneralInput
                  id="work-language10"
                  label={translate.language[language]}
                  type="text"
                  placeholder={translate.enter_lang[language]}
                />
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setreadBool10(false)
                    }, 250)
                  }
                >
                  <p>{translate.reading[language]}</p>
                  <span tabIndex="1" onClick={() => setreadBool10(true)}>
                    {reading10} <LangArrows />
                  </span>
                  <ul
                    style={
                      readBool10 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setReading10(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setwritingBool10(false)
                    }, 250)
                  }
                >
                  <p>{translate.writing[language]}</p>
                  <span tabIndex="1" onClick={() => setwritingBool10(true)}>
                    {writing10} <LangArrows />
                  </span>
                  <ul
                    style={
                      writingBool10 ? { display: 'block' } : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setwriting10(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setspeakingBool10(false)
                    }, 250)
                  }
                >
                  <p>{translate.speaking[language]}</p>
                  <span tabIndex="1" onClick={() => setspeakingBool10(true)}>
                    {speaking10} <LangArrows />
                  </span>
                  <ul
                    style={
                      speakingBool10
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setspeaking10(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  className={styles.select}
                  onBlur={() =>
                    setTimeout(function () {
                      setlisteningBool10(false)
                    }, 250)
                  }
                >
                  <p>{translate.listening[language]}</p>
                  <span tabIndex="1" onClick={() => setlisteningBool10(true)}>
                    {listening10} <LangArrows />
                  </span>
                  <ul
                    style={
                      listeningBool10
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    {percents.map((e) => (
                      <li
                        onClick={() => {
                          setlistening10(e)
                        }}
                      >
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel onClick={() => setBoollang10(false)} />
              </div>
            ) : null}
          </div>
          {!boollang10 && (
            <button
              onClick={() => {
                addLang()
              }}
              className={styles.button}
            >
              <Plus /> {translate.add_lang[language]}
            </button>
          )}
          <h2>
            <Work /> {language === 'AZ' ? 'Bacarıqlar' : language === 'TR' ? 'Yetenekler ve Beceriler' : language === 'RU' ? 'Профессиональные навыки' : 'Professional Skills'}
            <span>({language === 'AZ' ? 'əgər bacarığınız yoxdursa, boş buraxın' : language === 'TR' ? 'yoksa boş bırakabilirsiniz' : 'optional'})</span>
          </h2>
          <div className={styles.skillsWrapper}>
            {skillsList.map((skill) => (
              <div key={skill.id} className={styles.skillRow}>
                <GeneralInput
                  label={language === 'AZ' ? 'Bacarığın adı' : language === 'TR' ? 'Beceri Adı' : language === 'RU' ? 'Название навыка' : 'Skill Name'}
                  type="text"
                  placeholder={
                    language === 'AZ'
                      ? 'Məsələn: 1C 8.3, BTP, Excel, Vergi Məcəlləsi...'
                      : language === 'TR'
                      ? 'Örneğin: 1C, Excel, Logo, Vergi Mevzuatı...'
                      : language === 'RU'
                      ? 'Например: 1C 8.3, BTP, Excel, Налоговый кодекс...'
                      : 'E.g.: 1C 8.3, BTP, Excel, Tax Code...'
                  }
                  value={skill.name}
                  onInput={(e) => updateSkillName(skill.id, e.target.value)}
                />
                <div
                  className={styles.skillSelect}
                  onBlur={() =>
                    setTimeout(function () {
                      setSkillsList((prev) =>
                        prev.map((s) => (s.id === skill.id ? { ...s, bool: false } : s))
                      )
                    }, 250)
                  }
                >
                  <p>{language === 'AZ' ? 'Səviyyə' : language === 'TR' ? 'Seviye' : language === 'RU' ? 'Уровень' : 'Level'}</p>
                  <span tabIndex="1" onClick={() => toggleSkillDropdown(skill.id)}>
                    {skill.level} <LangArrows />
                  </span>
                  <ul style={skill.bool ? { display: 'block' } : { display: 'none' }}>
                    {skillLevels.map((lvl, lidx) => (
                      <li
                        key={lidx}
                        onClick={() => updateSkillLevel(skill.id, lvl[language] || lvl.TR || lvl.AZ)}
                      >
                        {lvl[language] || lvl.TR || lvl.AZ}
                      </li>
                    ))}
                  </ul>
                </div>
                <Cancel className={styles.skillCancel} onClick={() => removeSkill(skill.id)} />
              </div>
            ))}
          </div>
          <button
            type="button"
            onClick={addSkill}
            className={styles.button}
            style={{ marginBottom: '32px' }}
          >
            <Plus /> {language === 'AZ' ? 'Bacarıq əlavə et' : language === 'TR' ? 'Yeni beceri ekleyin' : language === 'RU' ? 'Добавить навык' : 'Add Skill'}
          </button>
          <h2>
            <Work /> {translate.experience[language]}
            <span>({translate.work_info[language]})</span>
          </h2>
          <div className={styles.experience}>
            <GeneralInput
              label={translate.current_company[language]}
              id="work-company"
              type="text"
              placeholder={translate.enter_company[language]}
            />
            <GeneralInput
              label={translate.current_position[language]}
              id="work-position"
              type="text"
              placeholder={translate.enter_position[language]}
            />
            <GeneralInput
              label={translate.general_experience[language]}
              id="work-experience"
              type="text"
              placeholder={translate.eg1[language]}
            />
            <GeneralInput
              label={translate.relevant_field[language]}
              id="work-field"
              type="text"
              placeholder={translate.eg2[language]}
            />
          </div>
          <div className={styles.uploads}>
            <div>
              {selectedImage ? (
                <div className={styles.loaded}>
                  <span>{translate.upload_photo[language]}</span>
                  <p>{Helper.textLengthChecker(selectedImage.name, 18)}</p>
                  <Close
                    onClick={() => {
                      setSelectedImage(null)
                    }}
                  />
                </div>
              ) : (
                <div className={styles.simple}>
                  <span>{translate.upload_photo[language]}</span>
                  {translate.max_upload[language]}
                </div>
              )}

              <input
                type="button"
                value={translate.upload[language]}
                onClick={() => {
                  document.getElementById('file').click()
                }}
              />
              <input
                id="file"
                style={{ display: 'none' }}
                type="file"
                name="myImage"
                onChange={(event) => {
                  setSelectedImage(
                    event.target.files[0].size < 1048576
                      ? event.target.files[0]
                      : null,
                  )
                }}
              />
            </div>
            <div>
              {selectedFile ? (
                <div className={styles.loaded}>
                  <span>{translate.upload_resume[language]}</span>
                  <p>{Helper.textLengthChecker(selectedFile.name, 18)}</p>
                  <Close
                    onClick={() => {
                      setSelectedFile(null)
                    }}
                  />
                </div>
              ) : (
                <div className={styles.simple}>
                  <span>{translate.upload_resume[language]}</span>
                  {translate.upload_resume2[language]}
                </div>
              )}
              <input
                type="button"
                value={translate.upload[language]}
                onClick={() => {
                  document.getElementById('file2').click()
                }}
              />
              <input
                id="file2"
                style={{ display: 'none' }}
                type="file"
                name="myPdf"
                onChange={(event) => {
                  setSelectedFile(event.target.files[0])
                }}
              />
            </div>
          </div>
          <div className={styles.textarea}>
            <p>{translate.note[language]}</p>
            <span>{translate.not_required[language]}</span>
            <textarea
              id="work-note"
              placeholder={translate.write_note[language]}
            ></textarea>
          </div>
          <FormButton onClick={() => sendAppeal()}>
            {translate.save_next[language]}
          </FormButton>
        </div>
      </section>
      {module && (
        <div className={styles.module}>
          <Module
            email={document.getElementById('work-email').value.trim()}
            setModule={setModule}
            setVerify={setVerify}
            click={() => {
              setModule(false)
            }}
            verify={verify}
          />
        </div>
      )}
    </>
  ) : (
    <Loading />
  )
}

export default RemoteStep1
